import type { EditorView } from 'prosemirror-view'
import type { CellReference } from '../schemas'
import { copySourceLabel, numberedCopyText } from '../utils/copy-content'
import { cellEditorFragmentContent } from './content'

export function copyEditorSelection(view: EditorView, event: ClipboardEvent, references: CellReference[], matterId?: string, tableId?: string): boolean {
  if (!event.clipboardData || view.state.selection.empty) return false
  const segments = cellEditorFragmentContent(view.state.selection.content().content)
  const sources = new Map(references.map((reference) => [reference.id, copySourceLabel(reference, matterId, tableId)]))
  const text = numberedCopyText(segments, sources)
  const html = document.createElement('div')
  html.style.whiteSpace = 'pre-wrap'
  html.textContent = text
  event.clipboardData.setData('text/plain', text)
  event.clipboardData.setData('text/html', html.outerHTML)
  event.preventDefault()
  event.stopPropagation()
  if (event.type === 'cut' && view.editable) view.dispatch(view.state.tr.deleteSelection().scrollIntoView())
  return true
}
